import React from 'react'
import XLSX from 'xlsx'
import AppButton from '../../global/AppButton'
import ExportIcon from '@mui/icons-material/CloudDownload'

function ExportButton({ data, fileName, sheetName, columns, id }) {
    const exportExcel = () => {
        // Clean and reorder data based on table columns
        const cleanedData = data.map((row) => {
            const { _tableData, _id, ...cleanRow } = row

            // If columns definition is provided, use that order
            if (columns && Array.isArray(columns)) {
                const orderedRow = {}

                columns.forEach((col) => {
                    const field = col.field
                    if (field && field in cleanRow) {
                        // Use headerName as Excel column header, fallback to field name
                        const header = col.headerName || col.title || field
                        orderedRow[header] = cleanRow[field]
                    }
                })

                return orderedRow
            }

            return cleanRow
        })

        const workSheet = XLSX.utils.json_to_sheet(cleanedData)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, workSheet, sheetName)

        // Binary string
        XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' })

        // Download
        XLSX.writeFile(workbook, fileName)
    }

    return (
        <AppButton id={id} onClick={exportExcel} color='inherit' size='medium' variant='outlined' startIcon={<ExportIcon />}>
            Download current prices
        </AppButton>
    )
}

export default ExportButton
